import request from '@/utils/request'

// 新增购物车
export function getProductList(data) {
  return request({
    url: '/product/tiktokApi/getList',
    method: 'GET',
    params: data
  })
}

// 新增购物车
export function setActive(data) {
  return request({
    url: '/product/tiktokApi/setActive',
    method: 'POST',
    data: data,
    params: data
  })
}
// 新增购物车
export function syncByShopTiktok(data) {
  return request({
    url: '/product/tiktokApi/syncByShop',
    method: 'GET',
    params: data
  })
}
// 新增购物车
export function batchUpdate(data) {
  return request({
    url: '/product/tiktokApi/batchUpdate',
    method: 'POST',
    data: data
  })
}

// 新增购物车
export function addDraft(data) {
  return request({
    url: '/product/tiktokApi/addDraft',
    method: 'POST',
    data: data
  })
}

// 新增购物车
export function getBrand(data) {
  return request({
    url: '/product/tiktokApi/getBrand',
    method: 'GET',
    params: data
  })
}// 新增购物车
export function getWarehouse(data) {
  return request({
    url: '/product/tiktokApi/getWarehouseList',
    method: 'GET',
    params: data
  })
}
export function addProduct(data) {
  return request({
    url: '/product/tiktokApi/addProduct',
    method: 'POST',
    data: data
  })
}
export function getCategories(data) {
  return request({
    url: "/product/tiktokApi/getCategories",
    method: "GET",
    params: data,
  })
}
export function getAttributes(data) {
  return request({
    url: '/product/tiktokApi/getAttributes',
    method: 'GET',
    params: data
  })
}
export function syncByPIds(data) {
  return request({
    url: '/product/tiktokApi/syncByPIds',
    method: 'GET',
    params: data
  })
}
export function getListCnt(data) {
  return request({
    url: '/product/tiktokApi/getListCnt',
    method: 'GET',
    params: data
  })
}
export function getCategoryAttributeAllTiktok(data) {
  return request({
    url: '/product/tiktokApi/getAttributes',
    method: 'GET',
    params: data
  })
}
// 草稿箱删除TK产品
export function deletedraftProTiktok(data) {
  return request({
    url: '/product/tiktokApi/delete',
    method: 'POST',
    params: data
  })
}
